const requestStatus = {
  Unset: -1,
  Nuevo: 1,
  Cancelado: 3,
  EnProceso: 4,
  DocumentoCarta: 13,
  Sometida: 20,
  DevueltoPorFaltaInformacion: 21,
  Denegado: 22,
  RedaccionCarta: 23,
  Autorizado: 24,
  CanceladoDE: 25,
  DocumentoTesis: 27,
  EstadoInicial: 100,
  SinCerrar: 101,
  Asignadas: 102,
};

export const requestStatusColor = Object.freeze({
  [requestStatus.Nuevo]: 'green-light-1',
  [requestStatus.Cancelado]: 'black',
  [requestStatus.EnProceso]: 'orange-light-2',
  [requestStatus.DocumentoCarta]: 'blue',
  [requestStatus.Sometida]: 'pink',
  [requestStatus.DevueltoPorFaltaInformacion]: 'brown-3',
  [requestStatus.Denegado]: 'black',
  [requestStatus.Autorizado]: 'blue-light-2',
  [requestStatus.CanceladoDE]: 'black',
  [requestStatus.DocumentoTesis]: 'blue-light-2',
  [requestStatus.EstadoInicial]: 'green-4',
  [requestStatus.SinCerrar]: 'pink-4',
  [requestStatus.Asignadas]: 'blue-light-2',
  [requestStatus.RedaccionCarta]: 'blue-light-2',
});

export const requestStatusBgColor = Object.freeze({
  [requestStatus.Nuevo]: 'green-light-2',
  [requestStatus.Cancelado]: 'black',
  [requestStatus.EnProceso]: 'yellow-star-1',
  [requestStatus.DocumentoCarta]: 'red-light',
  [requestStatus.Sometida]: 'pink-2',
  [requestStatus.DevueltoPorFaltaInformacion]: 'brown-2',
  [requestStatus.Denegado]: 'black',
  [requestStatus.Autorizado]: 'blue-light-1',
  [requestStatus.CanceladoDE]: 'black',
  [requestStatus.DocumentoTesis]: 'blue-light-1',
  [requestStatus.EstadoInicial]: 'gray-21',
  [requestStatus.SinCerrar]: 'gray-21',
  [requestStatus.RedaccionCarta]: 'pink-2',

  [requestStatus.Asignadas]: 'blue-light-1',
});

export default requestStatus;
